import { createSelector } from 'reselect';

const tourSelector = (state) => state.tour;

export const selectTourRun = createSelector([tourSelector], (tour) => tour.run);

export const selectTourIndex = createSelector([tourSelector], (tour) => tour.stepIndex);
